package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.repository.RosterRepository
import kotlinx.coroutines.flow.Flow

class GetRosterUseCase(
    private val rosterRepository: RosterRepository
) {
    suspend operator fun invoke(rosterId: String): Result<Roster> {
        return rosterRepository.getRoster(rosterId)
    }

    /** SH-187: the roster as it changes (its status and version after a colleague's publish or edit). */
    fun observe(rosterId: String): Flow<Roster> = rosterRepository.observeRoster(rosterId)
}